import { useState } from "react";
import {
  getDispatchNote,
  createDispatchNotes,
  getDispatchNotesById,
  getAllWarehouses,
  patchDispatchNote,
  deleteDispatchNote
} from "../../../Services/inventoryService";
import toast from "react-hot-toast";
import { TOAST_MESSAGES } from "../constants";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";

export const useDispatchNote = () => {
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    search: null,
    product: null,
    warehouse: null,
  });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const onPageChange = (newPage) => setPage(newPage);

  const onPageSizeChange = (newSize) => {
    setRowsPerPage(newSize);
    setPage(1);
  };

  const fetchDispatchNotes = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getDispatchNote({
        ...params,
        ...filters,
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
      });
      if (response.status === 200) {
        setTotalPages(Math.max(1, Math.ceil((response.data?.count || 0) / rowsPerPage)));
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FETCH_DISPATCHNOTE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FETCH_DISPATCHNOTE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const postDispatchNotes = async (payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await createDispatchNotes(payload);
      if (response.status === 201) {
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.SITES_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_CREATE_STOCK
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchDispatchNotesById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getDispatchNotesById(id);
      if (response.status === 200) {
        data = response.data;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.FETCH_DISPATCHNOTE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FETCH_DISPATCHNOTE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const updateDispatchNote = async (rn_id, payload) => {
    setLoading(true);
    var data = null;
    try {
      const response = await patchDispatchNote(rn_id, payload);
      if (response.status === 200) {
        data = response.data;
        const msg = TOAST_MESSAGES.UPDATE_DISPATCHNOTE_SUCCESS;
        toast.success(msg);
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.UPDATE_DISPATCHNOTE_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.UPDATE_DISPATCHNOTE_FAILED
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const fetchWarehouses = async (params) => {
    setLoading(true);
    var data = null;
    try {
      const response = await getAllWarehouses({ ...filters, ...params }); //sequence is sensitive 
      if (response.status === 200) {
        data = response.data?.results;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.SITES_FETCH_FAILED;
        toast.error(msg);
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.FAILED_FETCH_WAREHOUSE
      );
    } finally {
      setLoading(false);
      return data;
    }
  };

  const deleteDispatchNoteById = async (id) => {
    setLoading(true);
    var data = null;
    try {
      const response = await deleteDispatchNote(id);
      if (response.status === 204) {
        toast.success(TOAST_MESSAGES.DELETE_DISPATCHNOTE_SUCCESS);
        data = true;
      } else {
        const msg =
          extractErrorMessage(response) || TOAST_MESSAGES.DELETE_DISPATCHNOTE_FAILED;
        toast.error(msg);
        data = false;
      }
    } catch (error) {
      toast.error(
        extractErrorMessage(error) || TOAST_MESSAGES.DELETE_DISPATCHNOTE_FAILED
      );
      data = false;
    } finally {
      setLoading(false);
      return data;
    }
  };

  return {
    loading,
    filters,
    setFilters,
    page,
    totalPages,
    rowsPerPage,
    onPageChange,
    onPageSizeChange,
    fetchDispatchNotes,
    fetchDispatchNotesById,
    deleteDispatchNoteById,
    fetchWarehouses,
    postDispatchNotes,
    updateDispatchNote
  };
};
